import styled from '@emotion/styled';
import { BaseButton } from '../base';

export const UndoneButton = styled(BaseButton)`
    width: auto;
    min-width: 0;
    padding: 0 7px;

    background-color: inherit;
`;
